import React from "react";
import { LockOutlined as LockIcon } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

export interface ViewOnlyIndicatorProps {
    reason?: string;
    compact?: boolean;
}

export const ViewOnlyIndicator: React.FC<ViewOnlyIndicatorProps> = ({
    reason = "You can view this Work Product, but you do not have permission to make changes.",
    compact = false
}) => (
    <Box
        role="status"
        aria-label={`View only. ${reason}`}
        title={reason}
        data-testid="view-only-indicator"
        sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "5px",
            px: compact ? "7px" : "9px",
            py: "4px",
            borderRadius: "999px",
            bgcolor: "rgba(71, 85, 105, 0.08)",
            border: "1px solid rgba(71, 85, 105, 0.18)",
            color: "#475569",
            flexShrink: 0
        }}
    >
        <LockIcon aria-hidden sx={{ fontSize: 14 }} />
        <Typography component="span" sx={{ fontSize: 11, fontWeight: 700, lineHeight: 1 }}>
            View only
        </Typography>
    </Box>
);
